<template>
  <el-dialog
    append-to-body
    title="修改取样点或装卸点"
    :visible.sync="dialogVisible"
    width="680px"
  >
    <el-form ref="form" label-position="left" label-width="80px" :model="form">
      <el-form-item
        label="取样点"
        prop="sampling_point_id"
        :rules="[
          { required: true, message: '请选择取样点', trigger: 'change' }
        ]"
      >
        <el-select
          class="w-96"
          v-model="form.sampling_point_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in samplingPointList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="是否加抽"
        prop="is_system_pumping"
        :rules="[
          { required: true, message: '请选择是否加抽', trigger: 'change' }
        ]"
      >
        <el-radio-group v-model="form.is_system_pumping">
          <el-radio :label="0">不加抽</el-radio>
          <el-radio :label="1">加抽</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="装卸点"
        prop="warehouse_id"
        :rules="[
          { required: true, message: '请选择装卸点', trigger: 'change' }
        ]"
      >
        <el-select
          class="w-96"
          v-model="form.warehouse_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      samplingPointList: [],
      warehouseList: [],
      form: {
        booking_id: "",
        sampling_point_id: "",
        warehouse_id: "",
        is_system_pumping: 0
      }
    };
  },
  methods: {
    onOpen(booking_info_id) {
      this.dialogVisible = true;
      this.getDetail(booking_info_id);
    },
    onConfirm() {
      this.$refs.form.validate(async v => {
        if (v) {
          try {
            await this.$common.http({
              url: "/api/queue/admin/update_booking_warehouse",
              data: this.form
            });
            this.dialogVisible = false;
          } catch (error) {
            console.log(error);
          }
          this.$emit("ok");
        }
      });
    },
    async getDetail(booking_info_id) {
      const res = await this.$common.http({
        url: "/api/queue/admin/query_booking_detail",
        data: {
          booking_info_id
        }
      });
      const {
        id: booking_id,
        queue: { sampling_point_id, warehouse_id, is_system_pumping }
      } = res.data.data;
      this.form = {
        booking_id,
        sampling_point_id,
        warehouse_id,
        is_system_pumping
      };
    },
    getSamplingPoint() {
      this.$common
        .http({
          url: "/api/queue/dispatcher/query_sampling_point",
          data: {
            is_admin: 1
          }
        })
        .then(res => {
          this.samplingPointList = res.data.data;
        });
    },
    getWarehouse() {
      this.$common
        .http({
          url: "/api/queue/dispatcher/query_warehouse",
          data: {
            is_admin: 1
          }
        })
        .then(res => {
          this.warehouseList = res.data.data;
        });
    }
  },
  created() {
    this.getSamplingPoint();
    this.getWarehouse();
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px !important;
}
</style>